import { render } from "./settingMenu.back.vue?vue&type=template&id=2701bac2"
import script from "./settingMenu.back.vue?vue&type=script&lang=js"
export * from "./settingMenu.back.vue?vue&type=script&lang=js"

import "./settingMenu.back.vue?vue&type=style&index=0&id=2701bac2&lang=less"
script.render = render

export default script